// extracted by mini-css-extract-plugin
module.exports = {"playerCard":"style_playerCard__hp_Mf","title":"style_title___nCrw","playerImg":"style_playerImg__eymCE","imgBlock":"style_imgBlock__G3n8c","score":"style_score__6Oh3p"};